function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "34",
  height: "23",
  viewBox: "0 0 34 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M30.651 16.327L34 19.593 30.508 23H0v-6.673h30.651z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.905 8.162l3.348 3.269-3.492 3.407H0V8.162h23.905z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.159 0l3.348 3.266-3.492 3.407H0V0h17.159z",
  fill: "#fff"
})));